import AppSpinner from "@/components/AppSpinner.vue";
import BaseButton from "@/components/BaseButton.vue";
import VDocument from "@/components/VDocument.vue";

import { BootstrapVue } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";

import moment from "moment";
import "moment/locale/fr";
import Vue from "vue";

//@ts-ignore
import Notifications from "vue-notification";
import App from "./App.vue";

import "./assets/styles/index.css";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";

Vue.config.productionTip = false;

// Components
Vue.component("v-document", VDocument);
Vue.component("b-button", BaseButton);
Vue.component("spinner", AppSpinner);
Vue.use(BootstrapVue);

// Vue use
Vue.use(Notifications);
//Vue.use( vueMoment );

// Filter
Vue.filter(
  "moment",
  function (date: string, format: string | undefined = undefined) {
    if (!date) {
      return "À vous de nous le dire :)";
    }
    return moment(new Date(date)).format(format ? format : "Do MMMM YYYY");
  }
);

new Vue({
  router,
  store,
  //@ts-ignore
  vuetify,
  render: (h) => h(App),
  mounted: () => {
    if (window['jimo'] != null) {
        return;
    }

    window['jimo'] = [];
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://undercity.usejimo.com/jimo-invader.js';
    window['JIMO_PROJECT_ID'] = "24981c48-596f-438d-9ae2-4e3c2db095cc";
    document.getElementsByTagName('head')[0].appendChild(s);
  }
}).$mount("#app");
